import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { fetchAllFolders } from '@chegg-wt/core/state/folders/actions'
import { enableFoldersSelector } from '@chegg-wt/core/state/app/selectors'
import { Separator } from '../../styled'
import ProjectTypesList from './ProjectTypesList'
import FoldersList from './FoldersList'
import { ProjectMenuProps } from './types'
import { ProjectMenuContainer } from './styled'

export const ProjectMenu: React.FunctionComponent<ProjectMenuProps> = ({
  className = '',
  enableFolders,
  fetchAllFolders,
}) => {
  useEffect(() => {
    if (enableFolders) fetchAllFolders()
  }, [])

  return (
    <ProjectMenuContainer className={className}>
      <ProjectTypesList />
      {enableFolders ? (
        <>
          <Separator />
          <FoldersList />
        </>
      ) : null}
    </ProjectMenuContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  enableFolders: enableFoldersSelector(state),
})

const mapDispatchToProps = {
  fetchAllFolders,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectMenu)
